__turbopack_context__.v({
  "accordion": "FinanceSummary-module__IZ_nla__accordion",
  "wrapper": "FinanceSummary-module__IZ_nla__wrapper",
});
